import { render, staticRenderFns } from "./entitlementsManager.vue?vue&type=template&id=1e894c24"
import script from "./entitlementsManager.vue?vue&type=script&lang=js"
export * from "./entitlementsManager.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports